import React from "react";
import ReactLoading from "react-loading";

const LoadingOverlay = ({ isLoading }) => {
    if (!isLoading) return null;

    return (
        <div className="fixed top-0 left-0 w-full h-full bg-white bg-opacity-60 flex justify-center items-center z-50">
            <ReactLoading type="spin" color="#333" height={50} width={50} />
        </div>
    );
};

export default LoadingOverlay;
